import {
  CoreFlightsCfarOffersComponents,
  CORE_FLIGHTS_CFAR_NAME,
} from "@b2bportal/core-types";

import { default as CfarFintechMarketplaceProduct } from "./CfarFintechMarketplaceProduct.module.scss";
import { default as CfarHowItWorksDialog } from "./CfarHowItWorksDialog.module.scss";
import { default as CfarOfferSection } from "./CfarOfferSection.module.scss";
import { default as CfarOfferSectionBody } from "./CfarOfferSectionBody.module.scss";

export const CORE_FLIGHTS_CFAR_OFFERS_STYLE_OVERRIDES = {
  [CORE_FLIGHTS_CFAR_NAME]: {
    [CoreFlightsCfarOffersComponents.CfarHowItWorksDialog]:
      CfarHowItWorksDialog,
    [CoreFlightsCfarOffersComponents.CfarFintechMarketplaceProduct]:
      CfarFintechMarketplaceProduct,
    [CoreFlightsCfarOffersComponents.CfarOfferSection]: CfarOfferSection,
    [CoreFlightsCfarOffersComponents.CfarOfferSectionBody]:
      CfarOfferSectionBody,
  },
};
